var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_7640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 9.24641V4.10631C14.6653 3.13293 14.3138 2.19975 13.6889 1.51146C13.064 0.823172 12.2167 0.43598 11.333 0.434814L4.66634 0.434814C3.78261 0.43598 2.93538 0.823172 2.31049 1.51146C1.6856 2.19975 1.33407 3.13293 1.33301 4.10631V9.24641H14.6663Z",
    fill: "#1E7C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.7151H0.666667C0.489856 10.7151 0.320286 10.7925 0.195262 10.9302C0.0702379 11.0679 0 11.2546 0 11.4494C0 11.6441 0.0702379 11.8309 0.195262 11.9686C0.320286 12.1063 0.489856 12.1837 0.666667 12.1837H7.33333V15.1209H6C5.46957 15.1209 4.96086 15.353 4.58579 15.7661C4.21071 16.1792 4 16.7395 4 17.3238C4 17.5185 4.07024 17.7053 4.19526 17.843C4.32029 17.9807 4.48986 18.0581 4.66667 18.0581C4.84348 18.0581 5.01305 17.9807 5.13807 17.843C5.2631 17.7053 5.33333 17.5185 5.33333 17.3238C5.33333 17.129 5.40357 16.9423 5.5286 16.8046C5.65362 16.6668 5.82319 16.5895 6 16.5895H10C10.1768 16.5895 10.3464 16.6668 10.4714 16.8046C10.5964 16.9423 10.6667 17.129 10.6667 17.3238C10.6667 17.5185 10.7369 17.7053 10.8619 17.843C10.987 17.9807 11.1565 18.0581 11.3333 18.0581C11.5101 18.0581 11.6797 17.9807 11.8047 17.843C11.9298 17.7053 12 17.5185 12 17.3238C12 16.7395 11.7893 16.1792 11.4142 15.7661C11.0391 15.353 10.5304 15.1209 10 15.1209H8.66667V12.1837H15.3333C15.5101 12.1837 15.6797 12.1063 15.8047 11.9686C15.9298 11.8309 16 11.6441 16 11.4494C16 11.2546 15.9298 11.0679 15.8047 10.9302C15.6797 10.7925 15.5101 10.7151 15.3333 10.7151Z",
    fill: "#1E7C88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_7640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17.6232,
    fill: "white",
    transform: "translate(0 0.434814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.f2f469413a555570d23f100097a2064b.svg";
export { ForwardRef as ReactComponent };